export default function (value) {
  if (!value) {
    return 0;
  }
  const result = new Intl.NumberFormat('ru-RU').format(value);
  return result === 'не число'
    ? 0
    : result;
}
